<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            />
            <b-col
              cols="12"
              md="5"
              offset-md="1"
            >
              <!-- variant select -->
              <b-form-group
                label-for="client-type"
              >
                <v-select
                  v-if="$ability.can(constants.action.permissionEventLogsList, constants.resource.user)"
                  v-model="slug"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="slugsOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="slug"
                  :value="'add-user'"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          responsive
          :fields="fields"
          :items="logsData"
        />
        <logs-modal
          :log-data="showData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getLogs"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BTable,
  BRow,
  BCol,
  BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
// import i18n from '@/libs/i18n'
import LogsModal from './LogsModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormGroup,
    LogsModal,
  },
  data() {
    return {
      loader: false,
      logsData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      showData: {},
      modalLoader: true,
      constants,
      fromdate: '',
      tilldate: '',
      userId: '',
      userType: JSON.parse(localStorage.getItem('userData')).data.user_type,
      fields: [],
      filters: [],
      filteraArgs: [],
      slug: { label: 'Add User Logs', value: 'add-user' },
    }
  },
  setup() {
    const slugsOptions = [
      { label: 'Add User Logs', value: 'add-user' },
      { label: 'Edit User Logs', value: 'edit-user' },
      { label: 'Delete User Logs', value: 'delete-user' },
      { label: 'Add Client Logs', value: 'add-client' },
      { label: 'Edit Client Logs', value: 'edit-client' },
      { label: 'Delete Client Logs', value: 'delete-client' },
      { label: 'Client Files Logs', value: 'upload-client-files' },
      { label: 'Add Debtor Logs', value: 'add-debtor' },
      { label: 'Edit Debtor Logs', value: 'edit-debtor' },
      { label: 'Delete Debtor Logs', value: 'delete-debtor' },
      { label: 'Add Representative Logs', value: 'add-representative' },
      { label: 'Edit Representative Logs', value: 'edit-representative' },
      { label: 'Delete Representative Logs', value: 'delete-representative' },
      { label: 'Add Task Logs', value: 'add-task' },
      { label: 'Edit Task Logs', value: 'edit-task' },
      { label: 'Save API Settings Logs', value: 'save-api-settings' },
      { label: 'Save Default Settings Logs', value: 'save-default-settings' },
      { label: 'Create Debt Case Logs', value: 'create-debt-case' },
      { label: 'Approve Debt Case Logs', value: 'approve-debt-case' },
      { label: 'Resume Debt Case Logs', value: 'resume-debt-case' },
    ]
    return {
      slugsOptions,
    }
  },
  watch: {
    slug: {
      handler(newValue) {
        console.log('Selected users changed', newValue)
        this.getLogs(newValue)
      },
    },
  },
  created() {
    this.getLogs('add-user')
  },
  methods: {
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getLogs()
      }
    },
    async getLogs(val) {
      try {
        this.filteraArgs = []
        if (this.userType === 'super-admin' || this.userType === 'system-user') {
          this.filteraArgs.push({
            field_name: 'userID',
            function: '>=',
            condition_value: 0,
          })
        }
        if (this.userType === 'company') {
          this.userId = JSON.parse(localStorage.getItem('userData')).data.id
          this.filteraArgs.push({
            field_name: 'userID',
            function: '=',
            condition_value: this.userId,
          })
        }
        if (this.userType === 'user') {
          this.userId = JSON.parse(localStorage.getItem('userData')).data.added_by
          this.filteraArgs.push({
            field_name: 'userID',
            function: '=',
            condition_value: this.userId,
          })
        }
        this.loader = true
        const url = 'get'
        await axios.post(`${constants.baseUrl}/logs-api/${url}`, {
          slug: val,
          filters: [...this.filteraArgs],
        }).then(response => {
          if (response.data.status) {
            const data = response.data.data.event_log
            const logsFields = Object.keys(Object.assign({}, ...data))
            this.fields = [...logsFields]
            this.logsData = response.data.data.event_log
            this.loader = false
          }
        }).catch(error => {
          console.log('error', error.response.data.data)
          const errorData = error.response.data.data
          const logsFields = Object.keys(Object.assign({}, ...errorData))
          this.fields = [...logsFields]
          this.logsData = error.response.data.data
          this.loader = false
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getLog(item) {
      this.modalLoader = true
      this.showData = item
      this.modalLoader = false
    },
    async resetDateRange() {
      // do some thing
      this.fromdate = ''
      this.tilldate = ''
      await this.getLogs()
      return true
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
th.column-title div {
   width: max-content;
}
</style>
